import React, { useCallback, useState } from 'react'
import { CloseIcon, IconMobileNode, IconRoleNode, UserNodeIcon } from '../iconSet/IconSet';
import { sourceCustomStyles, targetCustomStyles } from '../workflowCanvas/CustomStyles';
import { RecipientRoleNodePropsTypes } from './FlowchartTypes';
import { Handle, Position, useReactFlow } from 'reactflow';

const RecipientRoleNode: React.FC<RecipientRoleNodePropsTypes> = ({ id, data }) => {
    
    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };

    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    return (
        <div className={`recipient-role-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <IconRoleNode width='2rem'/>
            <span>{data.data.name} - (Recipient Role)</span>
            {isHovering && (
                <div className={`node-close-ico`} onClick={deleteNode}>
                    <CloseIcon width='1rem' color="var(--color-main-red)"/>
                </div>
            )}  
            <Handle id='pdf-target-a' type='target' position={Position.Top} style={{...targetCustomStyles, background: "blue"}}/>
            {/* <Handle id='pdf-source-a' type='source' position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/> */}
        </div>
    );
};

export default RecipientRoleNode;